<template>
<div>
  <aside
    ref="asideEl"
    :class="[isOpen ? 'transform translate-x-0':'transform -translate-x-full invisible lg:visible', {'is-collapsed': collapse}]"
    class="aside-core bg-primary-50 dark:bg-darkblue flex flex-col z-2010 overflow-auto"
    :role="isFocusTrapActive ? 'dialog' : 'complementary'"
    :aria-modal="isFocusTrapActive ? 'true' : undefined"
    :aria-labelledby="isFocusTrapActive ? 'aside-dialog-title' : undefined"
    :aria-label="isFocusTrapActive ? undefined : $t('app.aside_nav_label')"
  >
    <h2 id="aside-dialog-title" class="sr-only">{{ $t('app.aside_nav_label') }}</h2>
    <figure class="lg:hidden flex-none flex items-center justify-center bg-white dark:bg-darkblue select-none">
      <base-logo
        :filename="logo"
        :apiImage="true"
        alt="EdasNEO"
        class="brand p-2 max-h-20 logo-top-aside"
      />
    </figure>
    <div class="relative overflow-auto h-full dark:bg-darkblue select-none" style="min-height: 50vh;">
      <base-aside-main-nav
        class="relative z-20  lg:block"
        @cover="toggleCover"
        v-if="secondaryMenuOptions.length"
        :items="mainMenuOptions"
      />
      <nav
        aria-label="Navegación lateral"
        :class="{'opacity-25':cover}"
        class="aside-nav transition-opacity duration-300 mt-8"
        role="navigation"
      >
        <base-aside-nav
          :items="secondaryMenuOptions.length ? secondaryMenuOptions : mainMenuOptions"
        />
      </nav>
    </div>
    <div class="hidden flex items-center lg:block mt-auto justify-center py-2 collapsed-area select-none">
      <!-- <div class="flex flex-row"> -->
        <base-button-icon
            ariaLabel="Contraer o expandir menú lateral"
            @click="toggleCollapsed"
            :name="isCollapsed"
            mode="primary-phantom"
            class="bg-primary-100 hover:bg-primary-200 dark:bg-darkblue-800 dark:text-darkblue-200 rounded-full w-11 relative z-20"
          />
        <span class="flex items-center justify-center mb-2 relative z-10">
          <a
            href='https://www.zerocoma.com'
            target="_blank"
          >
          <base-logo-partner
            class="w-40 p-2"
            alt="Web de ZeroComa"
            :filename="logoPartner"
            />
          </a>
        </span>
      <!-- </div> -->
    </div>
    <footer class="flex-none pb-3 lg:hidden dark:bg-darkblue border-t dark:border-solid dark:border-darkblue-600 select-none">
      <div class="px-4 core-items flex items-center justify-between">
        <div class="py-3">
          <base-avatar 
            :isOpen="showOptions" 
            @toggleAvatar="toggleOptions" 
            v-bind:onMobile="true" 
            :custom="['bg-primary-100', 'dark:bg-darkblue-800', 'dark:hover:bg-darkblue-600', 'dark:text-darkblue-200']" />
            
            <base-drop-down
            :isOpen="showOptions"
            position="relative top-left"
            autoClose=false
            :absolute="false"
            @toggle="toggleOptions"
            class="fixed"
          >
            <ul class="p-1 divide-y divide-gray-100 dark:divide-gray-800 dark:border-darkblue-600 cursor-pointer">
              <li>
                <button @click="changeDarkMode()" class="cursor-pointer group flex rounded-md items-center w-full px-2 py-2 text-sm bg-white dark:bg-darkblue dark:text-darkblue-200 lg:dark:bg-darkblue-900 hover:bg-primary-50 dark:hover:bg-darkblue hover:text-primary-800 active:bg-primary-100 dark:active:bg-darkblue-600 dark:focus:bg-darkblue-600 dark:focus:text-primary">
                  <base-icon name="darktheme" class="mr-2" :ariaHidden="true"/>
                  {{ mode }}
                </button>
              </li>
              <base-link-item-nav v-for="option in userOptions" :option="option" :key="option.name" />
            </ul>
          </base-drop-down>
        </div>
        <div ref="languageActive" v-if="false"
          >
          <base-language
            :isOpen="languageActive" 
            @toggleLanguage="toggleLanguage" 
            v-bind:onMobile="true" 
            :custom="['bg-primary-100', 'dark:bg-darkblue-800', 'dark:hover:bg-darkblue-600', 'dark:text-darkblue-200']" />
        </div>
        <div class="">
          <base-button-icon
            ariaLabel="Redirigir al dashboard"
            @click="gotoDashboard"
            name="dashboard"
            mode="bubble"
            class="bg-primary-100 dark:bg-darkblue-800 dark:text-darkblue-200 dark:hover:bg-darkblue-600 rounded-full hover:text-primary dark:hover:text-primary"
          />
        </div>
        <div class="relative">
          <base-button-icon
            ariaLabel="Mostrar u ocultar avisos"
            @click="toggleNotifications"
            name="bell"
            mode="bubble"
            class="bg-primary-100 dark:bg-darkblue-800 dark:text-darkblue-200 dark:hover:bg-darkblue-600 rounded-full hover:text-primary dark:hover:text-primary"
          />
          <span v-if="announcements !== null && announcements.length > 0 " class='badge badge-warning absolute top-2 right-0 z-20' :class="alreadyVisited ? 'badge-count-visited' : 'badge-count'"> {{ total }} </span>
          <span 
            v-show="actualFilterAlerts" 
            class='badge badge-warning absolute top-2 left-2 z-20 badge-count-visited' 
            v-popover:popover
            tabindex="-1"
            >
            <base-icon name="filter" size="xs"/>
          </span>
          <el-popover
            :tabindex="-1"
            ref="popover"
            placement="top"
            width="320"
            trigger="hover"
            popper-class="dark:bg-darkblue dark:border-darkblue-600 dark:text-darkblue-200"
            >
            <div>
              <div v-if="actualFilterAlerts">
                <div class="flex items-center justify-between">
                  <span class="text-lg">Filtro de cliente</span>
                  <base-button-icon
                    ariaLabel="Reestablecer filtro de cliente"
                    @click="resetAlertsFilter()"
                    name="cross"
                    iconSize="xs"
                    titleIcon="Cancelar filtro"
                    size="xs"
                    mode="primary-phantom"
                    class="ml-2 bg-primary-100 hover:bg-primary-200 dark:bg-darkblue-800 dark:text-darkblue-200 rounded-full"
                  />
                </div>
                <div class="flex items-center justify-between">
                  <span>{{actualFilterAlerts.idCliente}} - {{actualFilterAlerts.Nombre}}</span>
                </div>
              </div>
              <div v-else>
                <span>Ningún filtro seleccionado</span>
              </div>
            </div>    
          </el-popover>
        </div>
          <base-drop-down
            :isOpen="languageActive"
            position="relative top-left"
            customClass="w-[10rem]"
            autoClose="true"
            @toggle="toggleLanguage"
            >
              <ul class="p-1 divide-y divide-gray-50 dark:divide-gray-800 dark:border-darkblue-600 cursor-pointer">
                <base-link-item-nav v-for="option in languagesOptions" :option="option" :key="option.value" />
              </ul>
          </base-drop-down>
          <base-drop-down
              :isOpen="nots"
              position="relative top-left"
              customClass="w-[18rem]"
              autoClose="true"
              @toggle="toggleNotifications"
            >
              <div class="p-4">
                <div v-if="announcements != null && announcements.length > 0">
                  <div class="lg:mb-4 flex flex-row" v-for="(announcement, index) in announcements" :key="index">
                      <div class="lg:px-2 w-full mb-2 lg:mb-0">
                        <router-link v-if="announcement.Enlace !== null" :to="{ name: announcement.Enlace }"
                            href="#" class="child w-full flex items-center  pr-4 h-8
                            hover:bg-primary-50 dark:hover:bg-darkblue-900 active:bg-primary-200 group animate-hover rounded">
                            <span
                              class="cover-subnav w-full overflow-hidden pl-2 flex h-full border-l-2 border-solid items-center dark:border-darkblue-600"
                            >
                            <span class="link-name max-w-alertrow truncate group-hover:text-primary-800 dark:text-gray-200">{{ announcement.Mensaje }}</span>
                          </span>
                        </router-link>
                        <button v-else-if="announcement.Accion !== null" @click="onclickAnnouncement(announcement.Accion)"
                          class="child w-full flex items-center pr-4 h-8 cursor-pointer hover:bg-primary-50 dark:hover:bg-darkblue-900 active:bg-primary-200 group animate-hover rounded">
                          <span class="cover-subnav w-full overflow-hidden pl-2 flex h-full border-l-2 border-solid items-center dark:border-darkblue-600">
                            <span class="link-name max-w-alertrow truncate group-hover:text-primary-800 dark:text-gray-200">{{ announcement.Mensaje }}</span>
                          </span>
                        </button>
                        <span v-else class="cover-subnav w-full truncate overflow-hidden pl-2 flex h-full border-l-2 border-solid items-center dark:text-gray-200 dark:border-darkblue-600">{{ announcement.Mensaje }}</span>
                      </div>
                      <div class="lg:px-2 mt-1 mb-2 lg:mb-0">
                          <span v-if="announcement.NumeroNotificaciones !== 0" class='badge badge-warning right-0 z-20 cart-count active:bg-primary-200'>
                            {{ announcement.NumeroNotificaciones }}
                          </span>
                      </div>
                  </div>
                </div>
                <div class="flex items-center justify-center dark:text-gray-200" v-else>
                  <p>{{$t('app.announcements_empty')}}</p>
                </div>
              </div>
            </base-drop-down>
      </div>
      <div class="px-4 flex flex-col items-center justify-center">
        <a
            href='https://www.zerocoma.com'
            target="_blank"
          >
          <base-logo-partner
            class="brand w-32 pb-4"
            alt="Web de ZeroComa"
            :filename="logoPartner"
          />
        </a>
        <base-button
          @click="toggleAside"
          mode="core"
          class="w-full"
          ariaLabel="Cerrar menú"
          text="Cerrar menú"
        />
      </div>
    </footer>
    <div class="absolute hidden top-0 left-0 w-full h-full bg-transparent z-10 select-none"
      v-if="cover"
    />
  </aside>
  <section>
    <help-dialog :dialogOpen="helpDialogOpen" @toggleDialog="toggleDialog" mobileVersion />
  </section>
</div>
</template>

<script>
// import CompanySelectorDropDown from '@/components/CompanySelectorDropDown.vue'
import { v4 as uuidv4 } from 'uuid'
// import { me } from '@/services/auth/me'
import { bus } from '@/main'
import HelpDialog from '@/components/HelpDialog.vue'
import { getApiBaseUrl, joinUrl } from '@/config/runtimeConfig'

export default {
  name: 'aside-core',
  props: {
    isOpen: {
      type: Boolean,
      default: false
    }
  },
  components: {
    HelpDialog,
  },
  data: function () {
    var self = this
    return {
      languageActive: false,
      helpDialogOpen: false,
      aside: false,
      cover: false,
      collapse: false,
      footerModalNav: false,
      showConfig: false,
      showOptions: false,
      companySelect: [],
      productSelect: [],
      languagesOptions: [
        {
          value: 'es-ES',
          name: 'Español',
          click: function () {
            self.setLocale('es-ES', bus)
          },
        }, 
        {
          value: 'en-EN',
          name: 'English',
          click: function () {
            self.setLocale('en-EN', bus)
          },
        },
      ],
      userOptions: [
        {
          icon: 'user',
          name: 'Mi perfil',
          click: function (store) {
            store.dispatch('auth/me', { navigate: true })
            this.showOptions = false
          }
        },
        {
          icon: 'help',
          name: 'Ayuda',
          click: function () {
            self.toggleAside()
            self.showHelp()
          }
        },
        {
          icon: 'logout',
          name: 'Cerrar sesión',
          click: function (store) {
            store.dispatch('auth/logout')
          }
        }
      ],
      configOptions: [],
      mainMenuOptions: [
        { 
          icon: 'notification', 
          name: 'Notificaciones', 
          path: 'notifications', 
          registerNavFromMenu: true, 
          sc: [], 
          subMenu: true 
        }, 
        {
          icon: 'companies', 
          name: 'Empresas', 
          path: 'companies', 
          registerNavFromMenu: true, 
          sc: [] 
        }, 
        { 
          icon: 'certificates', 
          name: 'Certificados', 
          path: 'certificates', 
          registerNavFromMenu: true, 
          sc: [] 
        }, 
        { 
          icon: 'config', 
          name: 'Configuración', 
          path: 'configurations', 
          registerNavFromMenu: true, 
          sc: [] 
        }, 
        { 
          icon: 'trash', 
          name: 'Papelera', 
          path: 'trash', 
          disabled: true, 
          registerNavFromMenu: true, 
          sc: [] 
        }
      ],
      secondaryMenuOptions: [],
      nots: false,
      alreadyVisited: false,
      total: 0,
      // Número de tooltips del aside actualmente abiertos (para gestionar el ESC del focus trap)
      openTooltipsCount: 0
    }
  },
  computed: {
    actualFilterAlerts () {
      return this.$store.getters['app/idClienteFilterAlerts']
    },
    darkMode: function () {
      return this.$store.getters['app/darkMode']
    },
    logo: function () {
      const pathBase = joinUrl(getApiBaseUrl(), 'api/empresas/getrecurso?hash=')
      const user = this.$store.getters['auth/user']

      // Personalizacion de logo
      if (user) {
        if (this.darkMode) {
          if (user.HashLogoDark) { 
            return pathBase + user.HashLogoDark 
          }
        } else {
          if (user.HashLogo) {
            return pathBase + user.HashLogo
          }
        }
      }

      if (this.darkMode) {
        return '/logos/edasneowhite.webp'
      }
      return '/logos/edasneo.webp'
    },
    logoPartner: function () {
      const user = this.$store.getters['auth/user']

      // Personalizacion de logo
      if (user) {
        if (this.darkMode) {
          if (user.LogoPortalDark) {
            return 'logo-zc-edasneo-dark.webp'
          }
        }
        if (user.LogoPortal) {
          return 'logo-zc-edasneo.webp'
        }
      }
      if (this.darkMode) {
        return 'logo-zc-dark.webp'
      }
      return 'logo-zc.webp'
    },
    asideBehaviour: function () {
      return {
        'transform translate-x-0': this.isOpen,
        'transform -translate-x-full invisible lg:visible': !this.isOpen,
        'is-collapsed': this.collapse
      }
    },
    announcements: function () {
      const announcements = []
      const value = this.$store.getters['app/getAnnouncementsList']
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      this.total = 0
      if (value != null) {
        value.forEach(element => {
          announcements.push(element)
          this.total += element.NumeroNotificaciones
        })
        /*
        announcements.push({ url: '', Mensaje: 'Tienes notificaciones para expirar', NumeroNotificaciones: 122 })
        announcements.push({ url: '', Mensaje: 'Tienes notificaciones para expirar', NumeroNotificaciones: 122 })
        announcements.push({ url: '', Mensaje: 'Tienes notificaciones para expirar', NumeroNotificaciones: 122 })
        announcements.push({ url: '', Mensaje: 'Tienes notificaciones para expirar', NumeroNotificaciones: 122 })
        announcements.push({ url: '', Mensaje: 'Tienes notificaciones para expirar', NumeroNotificaciones: 122 })
        announcements.push({ url: '', Mensaje: 'Tienes notificaciones para expirar', NumeroNotificaciones: 122 })
        */
      }
      return announcements
    },
    isCollapsed: function () {
      return (this.collapse ? 'expand' : 'collap')
    },
    mode: function () {
      if (this.darkMode === true) {
        return 'Modo Claro'
      } else {
        return 'Modo Oscuro'
      }
    },
    isLower1024: function () {
      return this.$store.getters['app/getIsLower1024']
    },
    isFocusTrapActive: function () {
      return this.isOpen && this.isLower1024
    },
    role: function () {
      return this.$store.getters['auth/role']
    }
  },
  watch: {
    isFocusTrapActive: function (active) {
      if (active) {
        this.activateFocusTrap()
      } else {
        this.deactivateFocusTrap()
      }
    },
    isLower1024: function (value, oldValue) {
      if (!value && this.helpDialogOpen) this.toggleDialog()
    },
    isOpen: function () {
      this.aside = this.isOpen
    },
    $route: function (to, from) {
      if (this.$tours.myTour.isRunning) this.$tours.myTour.stop()
      // this.$store.dispatch('app/updatetourFirstStepsActive', false)
      const menu = to?.meta?.secondaryMenu
      this.cover = false
      this.updateNotificationMenu()
      this.secondaryMenuOptions = this.$store.getters['menu/secondaryMenu'](menu, this.$route.params)
      const type = this.$route.params.type !== undefined && this.$route.params.type !== null && this.$route.params.type !== '' ? parseInt(this.$route.params.type) : null
      this.secondaryMenuOptions.forEach(sm => {
        if (sm.name === this.$i18n.t('app.notifications')) {
          if (type !== 99999) {
            // sm.name = this.headerTitle(type)
            sm.path = `${type}`
          }
        }
      })
      this.toggleAside()

      this.$store.dispatch('app/getAnnouncementsList')
      this.$store.dispatch('auth/getModules')
      this.$store.dispatch('auth/getPermisos')
    }
  },
  beforeMount: async function () {
    this.$store.dispatch('app/getColumnsVistas')
  },
  created () {
    bus.$on('changeIt', (data) => {
      // console.log('changeIt', data)
      this.updateNotificationMenu()
    })
    bus.$on('disableOptionsUser', (data) => {
      this.disableOptionsUser(data)
    })
    bus.$on('disableOptionsGroup', (data) => {
      this.disableOptionsGroup(data)
    })
    bus.$on('disableOptionsDistributor', (data) => {
      this.disableOptionsDistributor(data)
    })
    bus.$on('resetAndUpdateNav', (timeout) => {
      // console.log('resetAndUpdateNav')
      setTimeout(() => {
        this.resetAndUpdateNav()
      }, timeout)
    })
    bus.$on('asideTooltipVisibility', this.onAsideTooltipVisibility)
  },
  beforeDestroy () {
    this.deactivateFocusTrap()
    bus.$off('changeIt')
    bus.$off('disableOptionsUser')
    bus.$off('disableOptionsGroup')
    bus.$off('disableOptionsDistributor')
    bus.$off('resetAndUpdateNav')
    bus.$off('asideTooltipVisibility', this.onAsideTooltipVisibility)
    this.$root.$off('openNotesPatchMobile')
  },
  mounted: async function () {
    this.$root.$on('openNotesPatchMobile', () => {
      this.$emit('toogleAside')
      this.showHelp()
      this.$root.$emit('setControlFlagPatchNotes')
    })
    await this.$store.dispatch('auth/getModules')
    // await this.$store.dispatch('auth/getPermisos')

    this.resetAndUpdateNav()
  },
  methods: {
    activateFocusTrap () {
      // Guardamos el elemento que abrió el aside (p. ej. el botón hamburguesa)
      // para devolverle el foco al cerrar (WCAG 2.1 AA - 2.4.3).
      this._previouslyFocused = document.activeElement
      this.$nextTick(() => {
        const aside = this.$refs.asideEl
        if (!aside) return
        this._handleFocusTrapKeydown = (e) => {
          if (e.key === 'Escape') {
            if (this.isAnyTooltipOpen()) return

            this.toggleAside()
            return
          }
          if (e.key !== 'Tab') return
          const focusableSelectors = 'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
          const focusables = Array.from(aside.querySelectorAll(focusableSelectors)).filter(el => el.offsetParent !== null)
          if (!focusables.length) return
          const first = focusables[0]
          const last = focusables[focusables.length - 1]
          if (e.shiftKey) {
            if (document.activeElement === first) {
              e.preventDefault()
              last.focus()
            }
          } else {
            if (document.activeElement === last) {
              e.preventDefault()
              first.focus()
            }
          }
        }
        document.addEventListener('keydown', this._handleFocusTrapKeydown)
        // El aside se anima al abrir (transition-all incluye visibility), por lo que
        // durante la animación aún no es enfocable. Enfocamos el PRIMER elemento
        // interactuable visible al terminar la transición (WCAG 2.4.3), con fallback.
        const focusSelectors = 'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
        let focused = false
        const focusFirst = () => {
          if (focused) return
          focused = true
          aside.removeEventListener('transitionend', focusFirst)
          const el = Array.from(aside.querySelectorAll(focusSelectors)).find(node => node.offsetParent !== null)
          if (el) el.focus()
        }
        aside.addEventListener('transitionend', focusFirst)
        setTimeout(focusFirst, 300)
      })
    },
    deactivateFocusTrap () {
      if (this._handleFocusTrapKeydown) {
        document.removeEventListener('keydown', this._handleFocusTrapKeydown)
        this._handleFocusTrapKeydown = null
      }
      this.openTooltipsCount = 0
      // Devolvemos el foco al elemento que abrió el aside, si sigue visible.
      const prev = this._previouslyFocused
      this._previouslyFocused = null
      if (prev && typeof prev.focus === 'function' && prev.offsetParent !== null) {
        prev.focus()
      }
    },
    isAnyTooltipOpen () {
      return this.openTooltipsCount > 0
    },
    onAsideTooltipVisibility (visible) {
      setTimeout(() => {
        this.openTooltipsCount = Math.max(0, this.openTooltipsCount + (visible ? 1 : -1))
      }, 200)
    },
    resetAndUpdateNav () {
      const menu = this.$route?.meta?.secondaryMenu
      this.resetMainMenuOptions()
      this.updateNotificationMenu()
      this.secondaryMenuOptions = this.$store.getters['menu/secondaryMenu'](menu, this.$route.params)
      const type = this.$route.params.type !== undefined && this.$route.params.type !== null && this.$route.params.type !== '' ? parseInt(this.$route.params.type) : null
      this.secondaryMenuOptions.forEach(sm => {
        if (sm.name === this.$i18n.t('app.notifications')) {
          if (type !== 99999) {
          // sm.name = this.headerTitle(type)
            sm.path = `${type}`
          }
        }
      })
    },
    resetMainMenuOptions () {
      this.mainMenuOptions = []
      this.mainMenuOptions = this.$store.getters['menu/mainMenu']
    },
    resetAlertsFilter () {
      this.$store.dispatch('app/updateidClienteFilterAlerts', null)
      this.$store.dispatch('app/getAnnouncementsList')
    },
    onclickAnnouncement (action) {
      const data = { filters: [] }
      if (action === 'solicitudVacacionesError') {
        data.filters.push({ type: 'estadoDiasCortesiaAEATError', data: true })
        this.pushRouteNameAux(data, 'companies')
      } else if (action === 'consultaVacacionesError') {
        data.filters.push({ type: 'consultaDiasCortesiaAEATError', data: true })
        this.pushRouteNameAux(data, 'companies')
      } else if (action === 'cifsErrorHotfolder') {
        data.filters.push({ type: 'errorHotfolder', data: true })
        this.pushRouteNameAux(data, 'companies')
      } else if (action === 'cifsSinVigilarHotfolder') {
        data.filters.push({ type: 'sinVigilarHotfolder', data: true })
        this.pushRouteNameAux(data, 'companies')
      } else if (action === 'empresasDesactivadas') {
        data.filters.push({ type: 'alertaEmpresaDesactivada', data: true })
        this.pushRouteNameAux(data, 'companies')
      } else if (action === 'notificacionesEmailError') {
        data.filters.push({ type: 'notificacionesEmailError', data: true })
        this.pushRouteNameAux(data, 'notifications')
      } else if (action === 'notificacionesPresentacionesError') {
        data.filters.push({ type: 'notificacionesPresentacionesError', data: 2 })
        this.pushRouteNameAux(data, 'notifications')
      } else if (action === 'notificacionesPeticionError') {
        data.filters.push({ type: 'notificacionesPeticionError', data: true })
        this.pushRouteNameAux(data, 'notifications')
      } else if (action === 'diligenciasError') {
        data.filters.push({ type: 'diligenciasError', data: true })
        this.pushRouteNameAux(data, 'procedings')
      } else if (action === 'importacionesError') {
        data.filters.push({ type: 'tipoImportacionEstado', data: 2 })
        this.pushRouteNameAux(data, 'configurations/imports')
      } else if (action === 'clientesCertSAML2PorCaducar') {
        data.filters.push({ type: 'clientesCertSAML2PorCaducar', data: true })
        this.pushRouteNameAux(data, 'configurations/clients')
      } else if (action === 'clientesCertSAML2Caducados') {
        data.filters.push({ type: 'clientesCertSAML2Caducados', data: true })
        this.pushRouteNameAux(data, 'configurations/clients')
      } else if (action === 'sugerenciasPendientes') {
        data.filters.push({ type: 'sugerenciasPendientes', data: true })
        this.pushRouteNameAux(data, 'notifications')
      } else if (action === 'reincidenciaErrores') {
        data.filters.push({ type: 'reincidenciaErrores', data: true })
        this.pushRouteNameAux(data, 'notifications')
      } else {
        console.error('Acción inesperada: ' + action)
      }
    },
    pushRouteNameAux (data, name) {
      this.$router.push(
        {
          name: name, 
          params: { data: data }, 
          query: { _r: this.guid() } 
        })
    },
    showHelp: function () {
      this.toggleDialog()
    },
    toggleDialog: function () {
      this.helpDialogOpen = !this.helpDialogOpen
      if (!this.helpDialogOpen) this.$store.dispatch('app/updatelastVisitedPatchNotes')
    },
    disableOptionsUser: function (data) {
      this.secondaryMenuOptions.forEach(sm => {
        if (sm.name === this.$i18n.t('app.users')) {
          sm.sc.forEach(sc => {
            if (sc.path === 'configurations/users/groups') {
              sc.disabled = data.disableGroups
            }
            if (sc.path === 'configurations/users/companies') {
              sc.disabled = data.disableCompanies
            }
            if (sc.path === 'configurations/users/tags') {
              sc.disabled = data.disableTags
            }
            if (sc.path === 'configurations/users/status') {
              sc.disabled = data.disableStatuses
            }
          })
        }
      })
    },
    disableOptionsGroup: function (data) {
      this.secondaryMenuOptions.forEach(sm => {
        if (sm.name === this.$i18n.t('app.groups')) {
          sm.sc.forEach(sc => {
            if (sc.path === 'configurations/groups/users') {
              sc.disabled = data.disableUsers
            }
            if (sc.path === 'configurations/groups/companies') {
              sc.disabled = data.disableCompanies
            }
            if (sc.path === 'configurations/groups/status') {
              sc.disabled = data.disableStatuses
            }
            if (sc.path === 'configurations/groups/groups') {
              sc.disabled = data.disableGroups
            }
          })
        }
      })
    },
    disableOptionsDistributor (data) {
      this.secondaryMenuOptions.forEach(sm => {
        if (sm.name === this.$i18n.t('distributors.header')) {
          sm.sc.forEach(sc => {
            if (sc.path === 'configurations/distributors/modules') {
              sc.disabled = data.disableModules
            }
            if (sc.path === 'configurations/distributors/locations') {
              sc.disabled = data.disableLocations
            }
          })
        }
      })
    },
    toggleCover: function () {
      this.cover = !this.cover
    },
    toggleAside: function () {
      this.aside = false
      this.sendChanges()
      this.toggleAll()
    },
    toggleCollapsed: function () {
      this.collapse = !this.collapse
      this.sendChanges()
      this.$root.$emit('kendo-grid-componente-handle-resize')
    },
    toggleOptions: function () {
      this.showConfig = false
      this.showOptions = !this.showOptions
    },
    toggleConfig: function () {
      this.showOptions = false
      this.showConfig = !this.showConfig
    },
    toggleAll: function () {
      this.showOptions = false
      this.showConfig = false
      this.languageActive = false
    },
    toggleLanguage () {
      this.languageActive = !this.languageActive
    },
    closeLanguage: function () {
      this.languageActive = false
    },
    startTransition: function (el) {
      el.style.height = el.scrollHeight + 'px'
    },
    endTransition: function (el) {
      el.style.height = ''
    },
    sendChanges: function () {
      this.$emit('toggle', {
        aside: this.aside,
        collapse: this.collapse
      })
    },
    // headerTitle: function (type) {
    //   let header = this.$i18n.t('app.notifications')
    //   const notifications = this.$store.getters['app/notificationsStatusGroups']
    //   const notification = notifications.filter(sc => sc.idEstado === type)
    //   if (notification.length > 0) {
    //     header = notification[0].Descripcion
    //   }
    //   return header
    // },
    changeDarkMode: function () {
      this.$store.commit('app/setDarkMode', !this.darkMode)
    },
    gotoDashboard: function () {
      const uuid = this.guid()
      this.$router.push({ name: 'dashboard', params: { id: uuid } })
    },
    guid: function () {
      return uuidv4()
    },
    toggleNotifications: function () {
      this.nots = !this.nots
      this.alreadyVisited = true
    },
    announcementsTotal: function () {
      const value = this.$store.getters['app/getAnnouncementsList']
      let total = 0
      value.forEach(element => {
        total += element.NumeroNotificaciones
      })
      return total
    },
    updateNotificationMenu: async function () {
      if (this.role !== 'AdminDistribuidor') {
        // TODO Refactor subniveles
        await this.$store.dispatch('app/getNotificationsStatus')
        const notificationsGroups = this.$store.getters['app/notificationsStatusGroups']
        // console.log('notifications', notificationsGroups)
        if (notificationsGroups != null) {
          this.mainMenuOptions.forEach(element => {
            if (element.name === this.$i18n.t('app.notifications')) {
              element.sc = []
              element.subMenu = true

              // Recorremos grupos
              notificationsGroups.forEach(grupo => {
                var scGroup = {
                  name: grupo.Descripcion,
                  info: grupo.InfoAdicional,
                  registerNavFromMenu: false,
                  warning: grupo.Resaltado,
                  desplegado: grupo.Desplegado,
                  sc: []
                }
                // Recorremos estados del grupo
                grupo.Estados.forEach(estado => {
                  if (estado.Notificaciones > 0) {
                    const path = `${estado.idEstado}`
                    scGroup.sc.push({
                      name: estado.Descripcion,
                      info: estado.InfoAdicional,
                      path: path,
                      counter: estado.Notificaciones,
                      registerNavFromMenu: false,
                      warning: estado.Resaltado,
                      sc: []
                    })

                    // Agregamos ruta, si existe reemplaza
                    const newRoute = {
                      path: '/'+process.env.VUE_APP_ROUTE_BASE+'/notifications/' + path,
                      name: path,
                      components: { default: import('@/views/notifications/Notifications.vue') },
                      params: { id: estado.idEstado },
                      meta: { registerNavFromMenu: true, status: estado.idEstado }
                    }
                    this.$router.addRoute('notifications', newRoute)
                  }
                })

                if (scGroup.sc.length > 0) element.sc.push(scGroup)
              })
            }
          })
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.logo-top-aside{
  max-width: 8rem;
}

.logo-bottom-aside{
  max-width: 5rem;
}


.filter-black{
  filter: invert(100%) sepia(2%) saturate(6%) hue-rotate(335deg) brightness(104%) contrast(99%);
}
.filter-white{
  filter: invert(0%) sepia(2%) saturate(6%) hue-rotate(335deg) brightness(104%) contrast(99%);
}
.filter-main{
  filter: invert(70%) sepia(94%) saturate(776%) hue-rotate(168deg) brightness(98%) contrast(91%);
}
.aside-core {
  @apply w-full fixed top-0 left-0 z-50 h-full transition-all duration-200;
  @include breakpoint(lg) {
    @apply static transform-none w-aside flex-shrink-0;

  }
  .collapsed-area>div {
    @apply ml-30 transition-all duration-200;
  }
  &.is-collapsed {
    @include breakpoint(lg) {
      @apply w-18 absolute;
      z-index: 40;
      &:hover {
        @apply w-aside;
      }
      .collapsed-area>div {
        @apply mr-auto ml-3;
      }
    }
  }
}
.accordeon-enter-active,
.accordeon-leave-active {
  will-change: height;
  transition: height 0.2s ease;
}
.accordeon-enter,
.accordeon-leave-to {
  height: 0 !important;
}
.badge {
  padding-left: 9px;
  padding-right: 9px;
  -webkit-border-radius: 9px;
  -moz-border-radius: 9px;
  border-radius: 9px;
}
.badge-count {
    font-size: 12px;
    background: #ff0000;
    color: #fff;
    padding: 0 5px;
    vertical-align: top;
    margin-left: -10px;
    margin-top: -15px;
}
.cart-count {
    font-size: 16px;
    @apply bg-primary-800;
    color: #fff;
    padding: 5px 10px;
    vertical-align: center;
    margin-top: -15px;
}


.badge-count-visited {
    font-size: 12px;
    @apply bg-primary-800;
    @apply dark:bg-primary-500;
    color: #fff;
    padding: 0 5px;
    vertical-align: top;
    margin-left: -10px;
    margin-top: -15px;
}

</style>
